import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_API_BASE_URL;

export const encryptRole = (role) => {
  const encryptedRole = CryptoJS.AES.encrypt(role, SECRET_KEY).toString();
  localStorage.setItem('userRole', encryptedRole);
};

export const decryptRole = (encryptedRole) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedRole, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null; // or some default value
  }
};